export default __webpack_public_path__ + "static/media/Power_Magorzata Szmigiel_Mia sta woskiego renesansu PDF.0b5aaa86.pdf";